/*
  Summaries a user's allocation rules
*/
import { CurrencyFormatLabel } from '@/components/CurrencyFormatLabel'
import { formatCurrencyFromCents } from '@/utils/currencyHelpers'
import { AllocationRule } from '@/src/reducers/finances/allocationRulesReducer'
import { Card, CardColors, Link, Table, Text } from '@/ui'
import { useReselector } from '@/utils/sharedHooks'
import { getAllocationRules } from '@/src/selectors/allocationGuideSelectors'
import { TypographyStyles } from '@/styles'

export const AllocationRulesCard = () => {
  const allocationRules = useReselector(getAllocationRules)
  const renderAmount = (rule: AllocationRule) => {
    if (rule.ruleType === 'percentage') {
      return `${rule.percentage} %`
    } else {
      return (
        <CurrencyFormatLabel
          value={formatCurrencyFromCents(rule.amountInCents)}
        />
      )
    }
  }
  return (
    <Card color={CardColors.EMPHASIS}>
      <div className="flex items-center justify-between">
        <Text variant={TypographyStyles.H2}>Current Allocation Guide:</Text>
        <Link
          href="/allocation-guides/edit"
          newPage={false}
          trackMessage="clicked edit allocation guide"
        >
          Edit
        </Link>
      </div>

      <Table className="w-full mt-2">
        <Table.Body>
          {allocationRules &&
            Object.values(allocationRules).map((rule) => (
              <Table.Row key={rule.id}>
                <Table.Cell>{rule.ruleName}</Table.Cell>
                <Table.Cell>{renderAmount(rule)}</Table.Cell>
              </Table.Row>
            ))}
        </Table.Body>
      </Table>
    </Card>
  )
}
